import { v4 } from 'uuid'

import { SourceItem } from '@/endpoints/schemas'

export const createEmptySourceItem = (): SourceItem => ({
	id: -1,
	order: 0,
	alias: '',
	expression: '',
	// Don't set objectId/objectCode - leave undefined until user selects a source
	// Setting objectId: 0 causes backend errors ("Reference not found")
	uuid: v4(),
})
